@if (mfa && mfa.visibility) {
    <div [id]="'container-mfa-'+environment.data.brand" class="container-mfa">
        <div id="check-mfa-form">
            <span class="close-icon" aria-hidden="true" (click)="close()">&times;</span>
            <div class="row w-100 pl-3 pb-3 text-center">
                <div class="bold-text blue-color align-content-center w-100 pb-5 nudge-right">
                    Authentification sécurisée
                </div>
                @if (mfa.step == 1) {
                    <div class="col-12">
                        @if (phoneNumbers.length > 1) {
                            <div class="form-group flex-mfa">
                                <span class="bold-label-text float-left">À quel numéro voulez-vous recevoir le code de vérification envoyé par SMS* ?</span>
                                <select name="phoneNumber" class="custom-select mt-3" (change)="setSelectedPhoneNumber($event)">
                                    <option value="">Choisissez votre numéro</option>
                                    @for (line of phoneNumbers; track line) {
                                        <option value="{{ line }}" [selected]="line == mfa.destination">{{ line }}
                                        </option>
                                    }
                                </select>
                            </div>
                        } @else if (mfa && mfa.destination && !isEmailDestination()) {
                            <div class="form-group flex-mfa">
                                <span class="bold-label-text">Un code de validation vous sera envoyé par SMS au <strong>{{ mfa.destination }}</strong></span>
                            </div>
                        } @else if (mfa && mfa.destination && isEmailDestination()) {
                            <div class="form-group flex-mfa">
                                <span class="bold-label-text">Un code de validation vous sera envoyé par e-mail à <strong>{{ mfa.destination }}</strong></span>
                            </div>
                        }
                        @if (mfa.errorMessage) {
                            <div class="row w-100 ml-2 form-text error-message">{{ mfa.errorMessage }}</div>
                        }
                        @if ((mfa && mfa.destination) || phoneNumbers.length > 1) {
                            <button type="button" class="cta_btn level_2" (click)="sendCode()">Valider<span></span>
                            </button>
                        }
                    </div>
                }
                @if (mfa.step == 2) {
                    <div class="col-12">
                        <div class="form-group flex-mfa">
                            <label>
                                @if (!isEmailDestination()) {
                                    <span class="bold-label-text float-left">Un code vous a été envoyé par SMS au {{ mfa.destination }}
                                        . Merci de le saisir ci-dessous*:</span>
                                }
                                @if (isEmailDestination()) {
                                    <span class="bold-label-text float-left">Un code vous a été envoyé à {{ mfa.destination }}
                                        . Merci de le saisir ci-dessous*:</span>
                                }
                                <input type="text" class="form-control" placeholder="Votre code" [(ngModel)]="mfa.code">
                                @if (mfa.errorMessage) {
                                    <div class="row w-100 ml-2 form-text error-message">{{ mfa.errorMessage }}</div>
                                }
                            </label>
                        </div>
                        @if (displayResendCodeButton) {
                            <button type="button" class="cta_btn level_2" (click)="sendCode()">Renvoyer le
                                code<span></span></button>
                        }
                        <button type="button" class="cta_btn level_2" (click)="validate()">Valider<span></span></button>
                    </div>
                }
            </div>
        </div>
    </div>
}
